module.exports = __webpack_public_path__ + "static/media/oberflex-eucalyptust326-2560x1440.df316766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-eucalyptust326-2560x1440.jpg
// module id = 1009
// module chunks = 37